import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import { FeatureCard } from 'sections/Company/CodeOfEthics/types';
import { featureCardsData } from 'sections/Company/CodeOfEthics/data';
import styles from 'sections/Company/CodeOfEthics/components/SectionFeatures/SectionFeatures.module.scss';

const cn = classNames.bind(styles);

const SectionFeatures = (): ReactElement => {
  const featuresCards = featureCardsData.map((card: FeatureCard) => {
    return (
      <SwiperSlide key={card.id}>
        <div className={cn('swiper__slide')}>
          <img
            className={cn('swiper__slide-icon')}
            src={`/images/pages/Company/CodeOfEthics/${card.iconName}.svg`}
            alt={card.iconName}
          />
          <p className={cn('swiper__slide-description')}>
            {card.description}
          </p>
        </div>
      </SwiperSlide>
    );
  });

  return (
    <section className={cn('features')}>
      <div className={cn('container')}>

        <div className={cn('features__swiper-container')}>
          <Swiper
            className={cn('swiper')}
            modules={[Pagination, Autoplay]}
            slidesPerView={1}
            initialSlide={0}
            pagination={{ clickable: true }}
            centeredSlides={true}
            spaceBetween={10}
            loop={false}
            autoplay={true}
            autoHeight={false}
            breakpoints={{
              '769': {
                slidesPerView: 10,
                centeredSlides: false,
                loop: false,
              },
            }}
          >
            {featuresCards}
          </Swiper>
        </div>

      </div>
    </section>
  );
};

export default SectionFeatures;